module.exports = __webpack_public_path__ + "static/media/success.e271083c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/success.svg
 ** module id = 77
 ** module chunks = 0
 **/